import {
  RETRIEVE_PRODUCTS,
  RETRIEVE_PRODUCT_VIEW,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  RESTORE_PRODUCT,
  UPDATE_PRODUCT_STATUS,
  RETRIEVE_SALE_PRODUCTS
} from "../actions/types";

const initialState = { products: [], totalProductCount: 0, totalVariantCount: 0, saleproducts: [], saletotalProductCount: 0 };

const productReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_PRODUCTS:
      return {
        totalVariantCount: payload.variantCount,
        products: payload.listProducts,
        totalProductCount: payload.count,
      };

    case RETRIEVE_SALE_PRODUCTS:
      return {
        saleproducts: payload.listProducts,
        saletotalProductCount: payload.count,
      };

    case RETRIEVE_PRODUCT_VIEW:
      return payload;

    case CREATE_PRODUCT:
      return payload;

    case UPDATE_PRODUCT:
      return payload;

    case UPDATE_PRODUCT_STATUS:
      return {
        products: payload.rows,
        totalProductCount: state.totalProductCount,
      };

    case DELETE_PRODUCT:
      return {
        ...state,
        products: payload.rows,
        totalProductCount: state.totalProductCount,
      };

    case RESTORE_PRODUCT:
      return {
        ...state,
        products: payload.rows,
        totalProductCount: state.totalProductCount,
      };


    default:
      return state;
  }
};

export default productReducer;